import React, { Component } from 'react';

export enum ToastLevelType {
    success = 'success',
    warning = 'warning',
    info = 'info',
    error = 'error',
}

interface Props {
    toast: ToastType;
    onTimedOut: () => void;
}

export interface ToastType {
    id: string;
    text: string;
    type: ToastLevelType;
    timeout: number; // in ms
}

interface State {
    remainingTime: number;
}

const checkTime = 10;

class Toast extends Component<Props, State> {
    public timer: NodeJS.Timer;

    constructor (props: Props) {
        super(props);

        this.state = { remainingTime: props.toast.timeout };
    }

    public componentDidMount() {
        this.createTimer();
    }

    public componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    public onTimeout = () => {
        clearTimeout(this.timer);
        this.props.onTimedOut();
        return;
    }

    public createTimer = () => {
        this.timer = setTimeout(() => {
            if (this.state.remainingTime < checkTime) {
                this.onTimeout();
                return;
            }
            this.setState({ remainingTime: this.state.remainingTime - checkTime });
            this.createTimer();
        }, checkTime);
    }

    public render() {
        return (
            <div className={`toast toast-${this.props.toast.type.toString()}`}>
                <div className="toast-progress" style={{ width: `${(this.state.remainingTime / this.props.toast.timeout) * 100}%` }}/>
                <button type="button" className="toast-close-button" role="button" onClick={this.onTimeout}>×</button>
                <div className="toast-message">{this.props.toast.text}</div>
            </div>
        );
    }
}

export default Toast;


// WEBPACK FOOTER //
// ./src/components/Toast/Toast.tsx